import { useDispatch } from 'react-redux';
import { setSessionData,setLoading } from '../redux/dataSlice';
import api from '../axiosConfig';
import '../css/moderator.css'

const useFetchSessionData = () => {
  const dispatch = useDispatch();

  const fetchSessionData = async (apiRoute,sessionId) => {
    try {
      dispatch(setLoading(true));

      const response = await api.get(`/${apiRoute}/loadData?sessionId=${sessionId || -1}`);
      const data = response.data;

      dispatch(setSessionData({sessionData: data, currentQuestionIndex: data.currentQuestionIndex, sessionQuestions:  data.sessionQuestions, currentStep: data.allQuestions[data.currentQuestionIndex].step , attendeeSessionGroupID: null, leaderboardData: data.leaderboardData}));

      console.log('Session Data:', data);
      dispatch(setLoading(false));

    } catch (error) {
      console.error('Error fetching session data:', error);
    }
  };

  return fetchSessionData;
};

export default useFetchSessionData;
